import script from "./artemis-ads-pricing-structure.vue?vue&type=script&setup=true&lang=js"
export * from "./artemis-ads-pricing-structure.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__